export default __webpack_public_path__ + "static/media/pincho-hombre-negro.d895b1b4.png";